"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.callGuestCustomerEndpoint = void 0;
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const src_1 = require("..");
function callGuestCustomerEndpoint(firstName, lastName, email) {
    return __awaiter(this, void 0, void 0, function* () {
        const successReturnObject = Object.assign(Object.assign({}, checkout_frontend_library_1.baseReturnObject), { success: true });
        const { customer: prevCustomer } = (0, checkout_frontend_library_1.getApplicationState)();
        const previous = {
            email: prevCustomer.email_address,
            firstName: prevCustomer.first_name,
            lastName: prevCustomer.last_name
        };
        const userLogin = !!prevCustomer.platform_id && prevCustomer.platform_id !== '0';
        if (!userLogin) {
            if ((0, src_1.isObjectEmpty)(previous)) {
                return yield (0, checkout_frontend_library_1.addGuestCustomer)(firstName, lastName, email, prevCustomer.accepts_marketing, src_1.API_RETRY);
            }
            else if (!(0, src_1.isObjectEquals)({ firstName, lastName, email }, previous)) {
                return yield (0, checkout_frontend_library_1.updateCustomer)(firstName, lastName, email, prevCustomer.accepts_marketing, src_1.API_RETRY);
            }
            else {
                return successReturnObject;
            }
        }
        else {
            return successReturnObject;
        }
    });
}
exports.callGuestCustomerEndpoint = callGuestCustomerEndpoint;
